import { render, staticRenderFns } from "./MLevel.vue?vue&type=template&id=4682c37e&scoped=true"
import script from "./MLevel.vue?vue&type=script&lang=js"
export * from "./MLevel.vue?vue&type=script&lang=js"
import style0 from "./MLevel.vue?vue&type=style&index=0&id=4682c37e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682c37e",
  null
  
)

export default component.exports